import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { FilialiComponent } from 'src/app/admin/filiali/filiali.component';
import { FormGroup } from '@angular/forms';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => FilialePickerComponent) },
  ],
  selector: 'filiale-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class FilialePickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(FilialiComponent, { data: { selectionMode: true } }).afterClosed();
  };

  parts: FormGroup = this.fb.group({
    humanIdentifier: [''],
    id: [''],
  });

  public writeValue(value?: any): any {
    if (value) {
      this.parts.patchValue({ 
          humanIdentifier: value["nome"],
          id: value.id 
      });
    } else
      this.parts.reset();
    this.stateChanges.next();
  }
}
